import {
  styled,
  Flex,
  $primaryColorsGreen,
  $white,
  $fontWeightBold,
  $fontWeightLight
} from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const Container = styled(Flex)`
  flex-direction: column;
  width: max-content;
`;

export const StepContainer = styled(Flex)`
  gap: 1rem;
  align-items: center;
  padding: 1rem;
  border-right: ${props =>
    props?.highlight && `2px solid ${$primaryColorsGreen.normal}`};
`;

export const StepCount = styled(Flex)`
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  background-color: ${props =>
    props?.highlight ? $primaryColorsGreen.normal : "#E7E7F0"};
  color: ${props => (props?.highlight ? $white : "#5B5675")};
`;

export const StepName = styled(Text)`
  font-size: 16px;
  line-height: 24px;
  font-weight: ${props =>
    props?.highlight ? $fontWeightBold : $fontWeightLight};
  color: ${props => (props?.highlight ? "#040222" : "#262626")};
`;
